<template>
  <div class="wrapper">
    <SideBar type="sidebar" />
    <Notifications />
    <TopNavbar />
    <DashboardContent @click.native="toggleSidebar" />
    <ContentFooter />
  </div>
</template>
<style lang="scss">

</style>
<script>
import TopNavbar from './TopNavbar/TopNavbar.vue'
import ContentFooter from './ContentFooter/ContentFooter.vue'
import DashboardContent from './Content.vue'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
